module.exports = __webpack_public_path__ + "img/dice2.a13ac3f4.svg";